import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import '../style/Product.css';
import Sidebar from '../components/Sidebar';
import {auth} from '../firebase';



const tShirts = [
  {
    id: 1,
    name: 'Oversized T-shirt',
    image: 'whiteF5.png', // Replace with actual path
  },
  // {
  //   id: 2,
  //   name: 'Black Oversized T-shirt',
  //   image: 'blackF1.png', // Replace with actual path
  // },
  {
    id: 2,
    name: 'Regular Fit T-shirt',
    image: 'BlackFitB.png', // Replace with actual path
  },

  {
    id: 3,
    name: 'Baby Tee',
    image: 'BabyTeeBlackF.jpg', // Replace with actual path
  },

  {
    id: 4,
    name: 'Joggers',
    image: 'joggersFront.jpg', // Replace with actual path
  },

    {
    id: 5,
    name: 'ADHD Exclusives',
    image: 'exclusives.jpg', // Replace with actual path
  },

      {
    id: 6,
    name: 'Hoodie',
    image: 'HoodieFront.jpg', // Replace with actual path
  }

];

const SelectTShirt = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const shop = queryParams.get('shop');
  const [isLoading, setIsLoading] = useState(true);
  const [filteredTshirts, setFilteredTshirts] = useState([]);

  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }

  useEffect(() => {
    // Simulate data loading with a small delay for better UX
    const loadData = () => {
      setIsLoading(true);
      
      // Small delay to show loading state
      setTimeout(() => {
        let filtered = [];
        if (user.uid !== '6Q1cEoMrjRXbzBMQzfwFeZWHi102') {
          filtered = tShirts.filter(tShirt => tShirt.id !== 5);
        }
        else {
          filtered = tShirts; // Show all items including exclusive for this specific user
        }
        setFilteredTshirts(filtered);
        setIsLoading(false);
      }, 300);
    };

    loadData();
  }, [user.uid]);

  const handleTShirtClick = (id) => {
    if (id === 4) { // Joggers ID
      navigate('/designjoggers');
    } 
    else if (id === 6) { // Hoodies ID
    navigate('/DesignHoodies');
     }
    else {
      navigate(`/SelectProduct`, { state: { id } });
    }
  };

return (
  <div className="flex h-screen bg-white">
    {/* Sidebar */}
    <Sidebar />

    {/* Main content */}
    <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
      <Header />
      <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
        {isLoading ? (
          <div className="flex justify-center items-center min-h-[400px]">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="loading-text">Loading products...</p>
            </div>
          </div>
        ) : (
          <div className="flex justify-center">
            <div className="grid gap-4 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 max-w-7xl w-full">
              {filteredTshirts.map((tShirt, index) => (
                <div
                  key={tShirt.id}
                  className="product-card-mobile"
                  onClick={() => handleTShirtClick(tShirt.id)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="product-image-container bg-white">
                    <img src={tShirt.image} alt={tShirt.name} className="product-image bg-white" />
                  </div>
                  <p className="tshirt-name">{tShirt.name}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>
    </div>
  </div>
);
};

export default SelectTShirt;